import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateVehicleSearch: Validator = (data: SearchContextType) => {
  const { registrationNumber, firstName, middleNames, lastName, dateOfBirth } =
    data;

  const hasVehicleReg = !!registrationNumber?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isVehicleOnlySearch = hasVehicleReg && !hasAnyOtherValue;

  if (!hasVehicleReg) {
    return { isValid: false, errors: [] };
  }

  return isVehicleOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidVehicle] };
};

export default validateVehicleSearch;
